import { format } from 'date-fns'

import { getThemedData } from '$app/utilities'

export const serviceName = getThemedData({
  carro: 'Carro SSO',
  partner: 'Partner SSO',
  motto: 'Motto SSO'
})

export const authenticatorAppName = getThemedData({
  carro: 'Carro ID',
  partner: 'Carro ID',
  motto: 'Carro ID'
})

export const authLayoutDescriptionText = (() => {
  const t = (text1: string, text2: string) => {
    return `To access the application from ${text1}, please log in with ${text2} service.`
  }

  return getThemedData({
    carro: t('CARRO', serviceName),
    partner: t('PARTNER', serviceName),
    motto: t('MOTTO', serviceName)
  })
})()

export const copyrightText = (() => {
  const year = format(new Date(), 'yyyy')

  return `&copy;${year} ${serviceName} Service. All rights reserved.`
})()

export const loginFormPlaceholderText = (() => {
  const email = (text: string) => `E.g. user@${text}`

  return {
    email: getThemedData({
      carro: email('carro.co'),
      partner: email('mail.com'),
      motto: email('mail.com')
    })
  }
})()
